module.exports = AMapUI;


//////////////////
// WEBPACK FOOTER
// external "AMapUI"
// module id = n+06
// module chunks = 0